import { ThemeUICSSObject } from 'theme-ui';
import getColorsAndStatesByPath from '../colors/util/getColorsAndStatesByPath';
/* IMPORT HERE */

const customCheckbox: ThemeUICSSObject = {
  display: 'inline-flex',
  borderRadius: 'default',
  flexBasis: '32px',
  flexShrink: 0,
  width: '32px',
  height: '32px',
  alignItems: 'center',
  justifyContent: 'center',
  p: '3px',
  border: '1px solid',
  svg: {
    width: '20px',
  },
  ...getColorsAndStatesByPath('form.fields', {
    states: {
      active: false,
      hover: false,
      focus: false,
      path: false,
    },
  }),

  /* PREPEND HERE */
};

export default customCheckbox;
